export const ALL_PAGES = -1;
